import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 所有権移転外ファイナンス */
enum OwnershipRightsNonTrfFinance {
  onBalance = '1',
  offBalance = '2',
}

const nameConfig = {
  onBalance: new Map([
    [Locale.ja, 'オンバランス'],
    [Locale.en, 'On Balance'],
  ]),
  offBalance: new Map([
    [Locale.ja, 'オフバランス'],
    [Locale.en, 'Off Balance'],
  ]),
};

const toEnum = rawValueToEnum(OwnershipRightsNonTrfFinance, OwnershipRightsNonTrfFinance.onBalance);
const toDisplay = enumToName(OwnershipRightsNonTrfFinance, nameConfig);
const toDisplayWithPrefix = enumToName(OwnershipRightsNonTrfFinance, nameConfig, { prefix: true });

export const ownershipRightsNonTrfFinance = {
  enum: OwnershipRightsNonTrfFinance,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { OwnershipRightsNonTrfFinance };
